import { ZodError } from 'zod'
import { DatabaseOperationError } from '@/db/errors'

export function getSafeErrorMessage(error: unknown) {
  if (error instanceof DatabaseOperationError) return error.userMessage
  if (error instanceof ZodError) return 'Revise os campos informados e tente novamente.'

  return 'Não foi possível concluir a ação. Tente novamente.'
}
